// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3RTr2","right":"Footer_right__2Ql0Y","buttons":"Footer_buttons__3sNAZ"};